export interface IPermission {
  uniqueId: string;
  name: string;
  description: string;
  authority: string;
  relateModule: keyof typeof EPermissionRelatedModule;
}

export enum EPermissionRelatedModule {
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  FIREARM = 'FIREARM',
  TRANSACTION = 'TRANSACTION',
  ADMINISTRATION = 'ADMINISTRATION',
  ANCILLARY = 'ANCILLARY',
  DASHBOARD = 'DASHBOARD',
  WEAPON_LICENCE = 'WEAPON_LICENCE',
  CASES = 'CASES',
}

export const permissionsGroups = [
  { title: 'roleDetails.legalEntity.section', module: EPermissionRelatedModule.LEGAL_ENTITY },
  { title: 'roleDetails.firearm.section', module: EPermissionRelatedModule.FIREARM },
  {
    title: 'roleDetails.ancillary.section',
    module: EPermissionRelatedModule.ANCILLARY,
  },
  {
    title: 'roleDetails.cases.section',
    module: EPermissionRelatedModule.CASES,
  },
  {
    title: 'roleDetails.weaponLicence.section',
    module: EPermissionRelatedModule.WEAPON_LICENCE,
  },
  {
    title: 'roleDetails.transaction.section',
    module: EPermissionRelatedModule.TRANSACTION,
  },
  {
    title: 'roleDetails.administration.section',
    module: EPermissionRelatedModule.ADMINISTRATION,
  },
  {
    title: 'roleDetails.dashboard.section',
    module: EPermissionRelatedModule.DASHBOARD,
  },
];

export const unlicensedToDisable = [
  'adbdab5a-5e4f-4a25-a4cc-f32e80253be0',
  '8c2112f0-4cb3-4905-8339-064822df0386',
  '5ef5ef2e-c566-4379-a0c9-28c410590818',
  '1396a510-cf01-4303-85b0-4f008029fd1c',
  '142f3fb4-0344-44d1-8752-3624ed263042',
  'ed44b66f-5fff-48b0-9c07-7e09304f77ee',
  '74be35fe-378a-4088-9a80-cfe8586addb1',
  '2ca453e2-392d-4ced-92bb-d10b419fda34',
];

export enum EPermission {
  /** Legal Entity Module  */
  DELETE_LE = 'DELETE_LE',
  MANAGE_COMMENTS_LE = 'MANAGE_COMMENTS_LE',
  EXPORT_LE = 'EXPORT_LE',
  VIEW_ALL_LE = 'VIEW_ALL_LE',
  VIEW_LE = 'VIEW_LE',
  VIEW_ANCILLARIES_LE = 'VIEW_ANCILLARIES_LE',
  VIEW_FIREARMS_LE = 'VIEW_FIREARMS_LE',
  MANAGE_LE = 'MANAGE_LE',
  MANAGE_GROUPS_LE = 'MANAGE_GROUPS_LE',
  VIEW_LICENCES_LE = 'VIEW_LICENCES_LE',
  VIEW_CASES_LE = 'VIEW_CASES_LE',

  /** Firearm Module  */
  VIEW_FIREARMS = 'VIEW_FIREARMS',
  VIEW_ALL_FIREARMS = 'VIEW_ALL_FIREARMS',
  MANAGE_COMMENTS_FIREARMS = 'MANAGE_COMMENTS_FIREARMS',
  MANAGE_ATTACHMENTS_FIREARMS = 'MANAGE_ATTACHMENTS_FIREARMS',
  DISABLE_FIREARM = 'DISABLE_FIREARM',
  MODIFY_FIREARM = 'MODIFY_FIREARM',
  MANAGE_FRT_FIREARM = 'MANAGE_FRT_FIREARM',
  EXPORT_FIREARMS = 'EXPORT_FIREARMS',
  MANAGE_IARMS_EXPORT = 'MANAGE_IARMS_EXPORT',

  /** Transaction Module  */
  ADD_TRANSACTION = 'ADD_TRANSACTION',
  VIEW_TRANSACTIONS = 'VIEW_TRANSACTIONS',
  VIEW_ALL_TRANSACTIONS = 'VIEW_ALL_TRANSACTIONS',
  DISCARD_TRANSACTION = 'DISCARD_TRANSACTION',
  MANAGE_TRANSACTION_COMMENTS = 'MANAGE_TRANSACTION_COMMENTS',
  EXPORT_TRANSACTIONS = 'EXPORT_TRANSACTIONS',

  /** Administration Module  */
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_ROLES = 'MANAGE_ROLES',
  MANAGE_CUSTOM_FIELDS = 'MANAGE_CUSTOM_FIELDS',
  MANAGE_SETTINGS = 'MANAGE_SETTINGS',
  VIEW_MODIFY_SYSTEM_PARAMETERS = 'VIEW_MODIFY_SYSTEM_PARAMETERS',
  VIEW_AUDIT_LOG = 'VIEW_AUDIT_LOG',
  EXPORT_AUDIT_LOG = 'EXPORT_AUDIT_LOG',
  MANAGE_DICTIONARIES = 'MANAGE_DICTIONARIES',
  VIEW_AND_MANAGE_LICENCE = 'VIEW_AND_MANAGE_LICENCE',
  MANAGE_API_KEYS = 'MANAGE_API_KEYS',
  MANAGE_LICENCE_AUTHORITY = 'MANAGE_LICENCE_AUTHORITY',

  /** Ancillaries Module  */
  VIEW_LIMITED_ANCILLARIES = 'VIEW_LIMITED_ANCILLARIES',
  VIEW_ALL_ANCILLARIES = 'VIEW_ALL_ANCILLARIES',
  EDIT_ANCILLARY = 'EDIT_ANCILLARY',
  DISABLE_ANCILLARY = 'DISABLE_ANCILLARY',
  MANAGE_LOCAL_ART = 'MANAGE_LOCAL_ART',
  MANAGE_COMMENTS_ANCILLARY = 'MANAGE_COMMENTS_ANCILLARY',
  MANAGE_ATTACHMENT_ANCILLARY = 'MANAGE_ATTACHMENT_ANCILLARY',
  EXPORT_ANCILLARIES = 'EXPORT_ANCILLARIES',

  /** Dashboard Module  */
  VIEW_DASHBOARD_CHARTS = 'VIEW_DASHBOARD_CHARTS',

  /** Weapon Licence */
  VIEW_GLOBAL_LICENCES = 'VIEW_GLOBAL_LICENCES',
  VIEW_RESTRICTED_LICENCES = 'VIEW_RESTRICTED_LICENCES',
  CREATE_MANAGE_LICENCE = 'CREATE_MANAGE_LICENCE',
  MANAGE_FILE_ATTACHMENTS = 'MANAGE_FILE_ATTACHMENTS',
  EXPORT_LICENCES = 'EXPORT_LICENCES',
  MANAGE_WEAPON_LICENCE_CONFIGURATOR = 'MANAGE_WEAPON_LICENCE_CONFIGURATOR',
  PRINT_LICENCE = 'PRINT_LICENCE',

  /** Case Management Module */
  VIEW_GLOBAL_CASES = 'VIEW_GLOBAL_CASES',
  VIEW_RESTRICTED_CASES = 'VIEW_RESTRICTED_CASES',
  ADD_CASES = 'ADD_CASES',
  VERIFY_CASES = 'VERIFY_CASES',
  ASSIGN_CASES_AND_TASKS = 'ASSIGN_CASES_AND_TASKS',
  ADD_DECISION = 'ADD_DECISION',
}

export enum EPermissionIds {
  /** Legal Entity Module  */
  VIEW_LE = 'b2625a10-7a39-11ee-b962-0242ac120002',
  MANAGE_LE = '180fe4af-360a-4761-805a-920d1b152d91',
  DELETE_LE = '2523fde6-193e-11ed-861d-0242ac120001',
  VIEW_ALL_LE = '299d9116-193e-11ed-861d-0242ac120001',
  MANAGE_COMMENTS_LE = '2f583566-193e-11ed-861d-0242ac120001',
  MANAGE_GROUPS_LE = '33c335c4-193e-11ed-861d-0242ac120001',
  VIEW_FIREARMS_LE = '386b84a0-193e-11ed-861d-0242ac120001',
  VIEW_ANCILLARIES_LE = '2d385ac0-f088-414d-a8a3-afb90b55e8da',
  VIEW_LICENCES_LE = '74be35fe-378a-4088-9a80-cfe8586addb1',
  EXPORT_LE = '3c505582-193e-11ed-861d-0242ac120001',
  VIEW_CASES_LE = 'b3ec1996-ede1-414e-8f19-fb8f2ae7ed1e',

  /** Firearm Module  */
  VIEW_FIREARMS = 'b73d2f95-0872-4064-a457-b12035e0e305',
  VIEW_ALL_FIREARMS = 'db08a9c3-d4a8-490e-8c98-a786bd116b6e',
  MANAGE_COMMENTS_FIREARMS = '6999d8a9-f219-4cf3-8ba2-ee2533c0095a',
  MANAGE_ATTACHMENTS_FIREARMS = '6c2c585f-6d0c-45dd-a9ad-cd5526cd237a',
  DISABLE_FIREARM = '3df425f5-7f8d-4694-bbc9-d0ceea8f13b0',
  MODIFY_FIREARM = '0956147e-b9a5-43f5-9002-7f6ae87e37dc',
  MANAGE_FRT_FIREARM = '25d117cd-b886-4983-b328-9964b0271397',
  EXPORT_FIREARMS = 'd19905f4-62dc-4068-a918-0ba188ca1142',

  /** Transaction Module  */
  ADD_TRANSACTION = '3101f8de-df11-4a1b-a21f-4a5a0e61472a',
  DISCARD_TRANSACTION = '502734eb-87f1-40fa-8a8b-b571d9776acb',
  VIEW_ALL_TRANSACTIONS = '45fad9c2-cb30-4c6b-96d7-5e974bc61c88',
  VIEW_TRANSACTIONS = 'ac3fa90a-f106-4388-afcf-06bc62e405f1',
  MANAGE_TRANSACTION_COMMENTS = '37507121-db55-403b-b25a-996405b7c696',
  EXPORT_TRANSACTIONS = 'f5e90b09-e722-4fb1-8628-f3dad1e56258',

  /** Administration Module  */
  MANAGE_USERS = '751ca6dc-b3ad-4648-8dfa-2c6cef2aa77b',
  MANAGE_ROLES = 'a32899ac-7eb5-4e12-a35a-191e87029676',
  MANAGE_CUSTOM_FIELDS = 'ad1653c3-953c-4850-a246-2a01d7a1559f',
  MANAGE_SETTINGS = '7782e2ac-7a2a-11ee-b962-0242ac120002',
  VIEW_AUDIT_LOG = 'e36f6738-7a2f-11ee-b962-0242ac120002',
  EXPORT_AUDIT_LOG = '14076eca-7c85-11ee-b962-0242ac120002',
  MANAGE_DICTIONARIES = '14f17976-8853-400c-9f8f-7b79d465f0e4',
  VIEW_AND_MANAGE_LICENCE = '43d53c80-c4d2-44d9-9128-e54d0e0eb7e2',
  MANAGE_API_KEYS = '888b92a9-4f9d-40e5-ab7b-106072cd33ed',
  MANAGE_LICENCE_AUTHORITY = 'c1fe37ac-2442-414a-8a2e-9c200007cef6',

  /** Ancillaries Module  */
  VIEW_LIMITED_ANCILLARIES = '8cf360b7-f3fc-4f6d-8f6a-23b2f1ce74b2',
  VIEW_ALL_ANCILLARIES = '831f60ce-048a-4780-858c-a987af64b33b',
  MANAGE_COMMENTS_ANCILLARY = '83f7453a-ea86-4616-b6ac-944daf1bb396',
  MANAGE_ATTACHMENT_ANCILLARY = '17fc2d2c-861c-4f0e-bbf9-0dfe119c120d',
  DISABLE_ANCILLARY = 'de29e6d6-d080-48b0-9e3e-a8633827ed56',
  EDIT_ANCILLARY = '669dabdd-75d4-437b-aa60-e5cd701911d5',
  MANAGE_LOCAL_ART = 'c17c999e-aede-4d3a-91e3-e904f9c1a0b8',
  EXPORT_ANCILLARIES = '2df8ec2f-1ab1-4bd3-a153-d06c76bce0a8',

  /** Dashboard Module  */
  VIEW_DASHBOARD_CHARTS = '222f5ada-e3db-461d-bfbb-ae674b546a92',

  /** Weapon Licence */
  VIEW_GLOBAL_LICENCES = 'ed44b66f-5fff-48b0-9c07-7e09304f77ee',
  VIEW_RESTRICTED_LICENCES = '142f3fb4-0344-44d1-8752-3624ed263042',
  CREATE_MANAGE_LICENCE = 'ae5f090b-4939-4da8-845c-f6d0ee876148',
  MANAGE_FILE_ATTACHMENTS = 'adbdab5a-5e4f-4a25-a4cc-f32e80253be0',
  EXPORT_LICENCES = '8c2112f0-4cb3-4905-8339-064822df0386',
  PRINT_LICENCE = '73463a74-5287-4500-8605-41dc2b5b702c',

  /** Case Management Module */
  VIEW_GLOBAL_CASES = 'd53e89c4-a690-410a-84bf-3cc6df7b29a5',
  VIEW_RESTRICTED_CASES = '3a9f1d85-c64a-4127-b519-d890cf2e6a71',
  ADD_CASES = 'a8b4c9d1-0f5e-4c3d-b2a1-6d7e0f8c3b5a',
  VERIFY_CASES = '5a8b1c4d-f9e0-4a2c-b3f7-0d5e6a1c2b9f',
  ASSIGN_CASES_AND_TASKS = 'e9b5c1a0-d2f4-48e7-b6a3-0d5f1c9b2e8a',
  ADD_DECISION = 'c1a9b5f0-d2e4-4a8b-f6c7-3d0e5a1b8c2f',
}
